import { useLocation } from "@tanstack/react-router";

// A custom hook that builds on useLocation to parse
// the query string for you.
const useURLQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default useURLQuery;
